import React from'react';
import { useNavigate } from'react-router-dom';

const DriverBusyPopup = ({ 
 driverName, 
 booking, 
 onClose 
}) => {
 const navigate = useNavigate();

 const handleChooseAnotherDriver = () => {
 // Prepare navigation state with booking data
 const navigationState = {
 pincode: booking?.pickupPincode ||'',
 vehicleType: booking?.vehicleType ||'',
 paymentMethod: booking?.paymentMethod ||'cash',
 pickupLocation: booking?.pickupLocation || booking?.pickupLocationName ||'',
 pickupLocationName: booking?.pickupLocationName || booking?.pickupLocation ||'',
 pickupPincode: booking?.pickupPincode ||'',
 pickupLandmark: booking?.pickupLandmark ||'',
 dropoffLocation: booking?.dropoffLocation ||'',
 dropoffLandmark: booking?.dropoffLandmark ||'',
 bookingType: booking?.bookingType ||'book-now',
 pickupPhoto: booking?.pickupPhoto || null,
 startDate: booking?.scheduledStartDate || null,
 startTime: booking?.scheduledStartTime || null,
 endDate: booking?.scheduledEndDate || null,
 excludedDriverId: booking?.driverId || null // Exclude the busy driver
 };

 console.log('🚗 Navigating to nearby drivers with state:', navigationState);

 // Navigate to nearby drivers page
 navigate('/nearby-drivers', { state: navigationState });

 // Close the popup
 if (onClose) {
 onClose();
 }
 };

 return (
 <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[10003] p-4">
 <div className="bg-white rounded-lg shadow-2xl max-w-md w-full animate-slideUp">
 <div className="p-6">
 <div className="flex items-center justify-center mb-4">
 <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center">
 <svg
 className="w-8 h-8 text-orange-600"fill="none"stroke="currentColor"viewBox="0 0 24 24">
 <path
 strokeLinecap="round"strokeLinejoin="round"strokeWidth={2}
 d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"/>
 </svg>
 </div>
 </div>
 <h3 className="text-xl font-bold text-gray-900 text-center mb-2">
 Driver Has Accepted Another Ride
 </h3>
 <p className="text-gray-600 text-center mb-6">
 {driverName ? (
 <>
 Driver <span className="font-semibold">{driverName}</span> has accepted another ride request. 
 Please choose another driver to continue with your booking.
 </>
 ) : ('The driver has accepted another ride request. Please choose another driver to continue with your booking.')}
 </p>
 <button
 onClick={handleChooseAnotherDriver}
 className="w-full px-6 py-3 bg-gray-900 hover:bg-gray-800 text-white rounded-lg font-semibold transition-colors flex items-center justify-center space-x-2">
 <svg
 className="w-5 h-5"fill="none"stroke="currentColor"viewBox="0 0 24 24">
 <path
 strokeLinecap="round"strokeLinejoin="round"strokeWidth={2}
 d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"/>
 </svg>
 <span>Choose Another Driver</span>
 </button>
 </div>
 </div>

 <style jsx>{`@keyframes slideUp {
 from {
 transform: translateY(20px);
 opacity: 0;
 }
 to {
 transform: translateY(0);
 opacity: 1;
 }
 }
 .animate-slideUp {
 animation: slideUp 0.3s ease-out;
 }`}</style>
 </div>
 );
};

export default DriverBusyPopup;

